import React from "react";
import { FiPhone, FiPhoneIncoming, FiPhoneOff, FiCheck } from "react-icons/fi";

const IncomingCallPopup = ({
  visible,
  caller,
  accountNo,
  onAccept,
  onReject,
  disabled = false,
  connecting = false,
  t,
}) => {
  if (!visible) return null;
  const title = t ? t("ccGlobalDialerIncoming") : "Incoming call";
  const acceptLabel = connecting
    ? t
      ? t("ccGlobalDialerConnecting")
      : "Connecting..."
    : t
      ? t("ccIncomingCallAccept")
      : "Accept";
  const rejectLabel = t ? t("ccIncomingCallReject") : "Reject";
  const unknownCaller = t ? t("ccUnknownCaller") : "Unknown caller";

  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
      <div className="bg-gradient-to-br from-[#2B7FFF] to-[#1d6ef2] px-4 py-5 text-center text-white">
        <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-white/15 ring-1 ring-white/25">
          <FiPhoneIncoming className="h-5 w-5" strokeWidth={2.25} aria-hidden="true" />
        </div>
        <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-white/70">{title}</p>
        <p className="mt-1.5 text-lg font-bold tracking-tight">{caller || unknownCaller}</p>
        {accountNo ? (
          <p className="mt-1 text-xs text-white/75">
            {t ? t("ccIncomingCallAccount") : "Account"}: {accountNo}
          </p>
        ) : null}
      </div>
      <div className="grid grid-cols-2 gap-2 p-3">
        <button
          className="inline-flex h-11 items-center justify-center gap-1.5 rounded-xl bg-rose-600 text-sm font-semibold text-white transition hover:bg-rose-700 disabled:cursor-not-allowed disabled:opacity-60"
          type="button"
          onClick={onReject}
          disabled={disabled}
        >
          <FiPhoneOff className="h-4 w-4" strokeWidth={2.25} aria-hidden="true" />
          {rejectLabel}
        </button>
        <button
          className="inline-flex h-11 items-center justify-center gap-1.5 rounded-xl bg-emerald-500 text-sm font-semibold text-white transition hover:bg-emerald-600 disabled:cursor-not-allowed disabled:opacity-60"
          type="button"
          onClick={onAccept}
          disabled={disabled}
        >
          {connecting ? (
            <FiPhone className="h-4 w-4 animate-pulse" strokeWidth={2.25} aria-hidden="true" />
          ) : (
            <FiCheck className="h-4 w-4" strokeWidth={2.25} aria-hidden="true" />
          )}
          {acceptLabel}
        </button>
      </div>
    </div>
  );
};

export default IncomingCallPopup;
